//外部リンク別タブで開く
const links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
   links[i].target = '_blank';
   links[i].rel = 'noreferrer noopener';
  }
}


//product-form-customのチェックボックス制御
document.addEventListener('DOMContentLoaded', function(event) {
  const targetButton = document.getElementById('addCart');
  const triggerCheckbox = document.querySelector('input[name="agree"]');

  triggerCheckbox.addEventListener('change', function() {
    if (this.checked) {
      // チェックされているときに実行する処理
      targetButton.disabled = false;
      targetButton.classList.remove('is-inactive');
      targetButton.classList.add('is-active');
    } else {
      // チェックが外れているときに実行する処理
      targetButton.disabled = true;
      targetButton.classList.remove('is-active');
      targetButton.classList.add('is-inactive');
    }
  }, false);

  // ボタンがクリックされたときにチェックされていなければアラートを表示
  targetButton.addEventListener('click', function(event) {
    if (!triggerCheckbox.checked) {
      // チェックされていない場合にアラートを表示
      alert('カートに追加する前に規約をご確認ください');
      event.preventDefault(); // ボタンの通常の動作を停止
    }
  });
}, false);


//main-cart
document.addEventListener('DOMContentLoaded', function() {
document.getElementById("btnReload").addEventListener("click", function(){
window.location.reload();
  })
});



